import type { Shipment } from '@/types/nest/shipment'
import { axiosClient } from '@/utils/axios-client'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useShipmentStore = defineStore('shipmentStore', () => {
  const shipments = ref<Shipment[]>([])

  async function fetchShipments(projectId?: string) {
    const response = await axiosClient.request<Shipment[]>({
      url: '/shipments',
      method: 'GET',
      params: {
        projectId,
      },
    })

    shipments.value = response.data
  }

  async function fetchShipment(id: string) {
    const response = await axiosClient.request<Shipment[]>({
      url: `/shipments/${id}`,
      method: 'GET',
    })

    shipments.value = response.data
  }

  async function createShipment(shipment: Shipment) {
    const response = await axiosClient.request<Shipment>({
      url: '/shipments',
      method: 'POST',
      data: shipment,
    })

    shipments.value.push(response.data)
  }

  async function updateShipment(shipment: Shipment) {
    const response = await axiosClient.request<Shipment>({
      url: `/shipments/${shipment.id}`,
      method: 'PUT',
      data: shipment,
    })

    const index = shipments.value.findIndex(shipment => shipment.id === shipment.id)
    if (index !== -1) {
      shipments.value[index] = response.data
    }
  }

  async function deleteShipment(shipmentId: string) {
    await axiosClient.request({
      url: `/shipments/${shipmentId}`,
      method: 'DELETE',
    })

    shipments.value = shipments.value.filter(shipment => shipment.id !== shipmentId)
  }

  return {
    shipments,
    fetchShipments,
    fetchShipment,
    createShipment,
    updateShipment,
    deleteShipment,
  }
})
